import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// VO == on-screen caption. Every number is from the real session:
//   forensics  → agent_usage_logs (31-char query, 13,839 tokens_in, 72,623 ms)
//   why        → Liu et al. "Lost in the Middle" (TACL 2024) · Chroma "Context Rot" 2025
//   fix        → src/lib/chat/trim-history.ts (per-message + total char budget) + model_config deep→flash
//   result     → live: 60s → 4.3s after the fix + Flash
// No fabricated numbers — each figure is a logged measurement or a cited paper.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "A thirty-one character question. Thirteen thousand tokens. Seventy-two seconds. Here's why your chatbot gets slower the longer you talk to it." },
];

export const FORENSICS: ScriptLine[] = [
  { scene: "forensics", fromSec: 0.4, holdSec: 5.0, caption: "I didn't guess — I read the logs. agent_usage_logs had the smoking gun, plain as day." },
  { scene: "forensics", fromSec: 5.6, holdSec: 5.4, caption: "A 31-character query was sending nearly fourteen thousand input tokens to the model. That's not retrieval — that's the conversation history." },
  { scene: "forensics", fromSec: 11.4, holdSec: 3.4, caption: "And each 'summarize everything' answer became history for the next one. A compounding feedback loop." },
];

export const WHY: ScriptLine[] = [
  { scene: "why", fromSec: 0.4, holdSec: 5.2, caption: "The instinct 'more history is smarter' is backwards. Big context makes answers WORSE, not just slower." },
  { scene: "why", fromSec: 5.8, holdSec: 5.2, caption: "Lost in the Middle: models lose what's buried in long context. Context Rot: every frontier model degrades as input grows." },
  { scene: "why", fromSec: 11.2, holdSec: 3.4, caption: "Three hundred focused tokens beat a hundred-thousand-token dump. Trimming is a QUALITY lever." },
];

export const FIX: ScriptLine[] = [
  { scene: "fix", fromSec: 0.4, holdSec: 5.2, caption: "The bug: history was capped by message COUNT — the last twenty — but never by SIZE." },
  { scene: "fix", fromSec: 5.8, holdSec: 5.6, caption: "The fix is small: budget the history by size. Cap each message, cap the total, keep the newest, never delete the raw transcript." },
  { scene: "fix", fromSec: 11.6, holdSec: 4.0, caption: "And point Deep mode at a Flash-class model. A lean prompt on a fast model is the whole game." },
];

export const RESULT: ScriptLine[] = [
  { scene: "result", fromSec: 0.4, holdSec: 5.4, caption: "Thirteen thousand tokens dropped to about three. The same recap question went from sixty-plus seconds to four-point-three." },
  { scene: "result", fromSec: 6.0, holdSec: 5.0, caption: "No new model. No bigger context window. Just less context, better placed, on a cheaper model." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.4, holdSec: 5.4, caption: "The lesson generalizes: response quality on a cheap model is a CONTEXT problem, not a model-size problem." },
  { scene: "lesson", fromSec: 6.0, holdSec: 5.2, caption: "A Flash model with a lean, relevant, well-ordered prompt beats a Pro model drowning in tokens — every time." },
  { scene: "lesson", fromSec: 11.4, holdSec: 3.6, caption: "That insight is the spine of everything that comes next: prove it, don't lose it, and consolidate while you sleep." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 4.4, caption: "Read the logs. Trim the context. Prove the change. The cheapest model, used well, wins." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
